module.exports = __webpack_public_path__ + "static/media/logoMM-white.2500af72.png";